import {ReloadButton,} from '@flexinet/ui-components';
import {Box,} from '@mantine/core';
import { useQueryClient } from '@tanstack/react-query';
import { codePipelinesKeys } from '../hooks/useCodePipelinesQuery';

export const ReloadRecordsButton = () => {
    const queryClient = useQueryClient();

    const handleReload = () => {
        queryClient.invalidateQueries({ queryKey: codePipelinesKeys.all });
    };

    return (
        <Box mx='s'>
            <ReloadButton onClick={handleReload}/>
        </Box>
    );
};
